/* NXTWAVE UI behaviours (2026 overhaul). No dependencies, no scroll listeners.
   Every animated behaviour checks prefers-reduced-motion and degrades to static. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('nx-js', 'nx-ui');
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var still = function () { return mq.matches; };

  /* Scroll reveal: sections and cards fade up once as they enter the viewport. */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || still()) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Announcement bar: one message at a time, crossfading. Static under reduced motion. */
  function initAnnouncements() {
    document.querySelectorAll('[data-nx-ann]').forEach(function (bar) {
      var msgs = bar.querySelectorAll('.nx-ann__msg');
      if (msgs.length < 2) return;
      var i = 0, timer = null;
      var show = function (n) { msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true'); i = n % msgs.length; msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden'); };
      var start = function () { if (!still() && !timer) timer = setInterval(function () { show(i + 1); }, 3800); };
      var stop = function () { clearInterval(timer); timer = null; };
      bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop); bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      start();
    });
  }

  /* Colourway turntable: a 3D ring of product cards. Auto-advances only while visible,
     supports drag/swipe, arrow buttons and keyboard, and pauses on hover/focus. */
  function initTurntable() {
    document.querySelectorAll('[data-nx-turntable]').forEach(function (tt) {
      var ring = tt.querySelector('.nx-tt__ring');
      var cards = Array.prototype.slice.call(tt.querySelectorAll('.nx-tt__card'));
      var n = cards.length; if (!ring || n < 2) return;
      var step = 360 / n, idx = 0, timer = null, visible = false;
      var buys = tt.querySelectorAll('[data-tt-buy] > div'), held = false;
      var name = tt.querySelector('[data-tt-name]'), price = tt.querySelector('[data-tt-price]'), link = tt.querySelector('[data-tt-link]');
      var dots = tt.querySelectorAll('[data-tt-dot]');
      function radius() { return Math.round((tt.querySelector('.nx-tt__stage').offsetWidth || 400) * 0.36); }
      function layout() {
        var r = radius();
        cards.forEach(function (c, k) { c.style.transform = 'rotateY(' + (k * step) + 'deg) translateZ(' + r + 'px)'; });
        ring.style.setProperty('--r', r + 'px');
        go(idx, true);
      }
      function go(k, instant) {
        idx = ((k % n) + n) % n;
        ring.style.transition = instant || still() ? 'none' : '';
        ring.style.transform = 'translateZ(calc(var(--r) * -1)) rotateY(' + (-idx * step) + 'deg)';
        cards.forEach(function (c, j) { var on = j === idx; c.classList.toggle('is-front', on); c.setAttribute('aria-hidden', on ? 'false' : 'true'); c.tabIndex = on ? 0 : -1; });
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
        var c = cards[idx];
        if (name) name.textContent = c.dataset.name;
        if (price) price.innerHTML = c.dataset.price;
        if (link) { link.href = c.dataset.url; link.setAttribute('aria-label', 'Shop ' + c.dataset.name); }
        buys.forEach(function (b, j) { b.hidden = j !== idx; });
      }
      function play() { if (!still() && visible && !held && !timer) timer = setInterval(function () { go(idx + 1); }, 3200); }
      function pause() { clearInterval(timer); timer = null; }
      tt.querySelectorAll('[data-tt-prev]').forEach(function (b) { b.addEventListener('click', function () { pause(); go(idx - 1); }); });
      tt.querySelectorAll('[data-tt-next]').forEach(function (b) { b.addEventListener('click', function () { pause(); go(idx + 1); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { pause(); go(j); }); });
      tt.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { pause(); go(idx - 1); } if (e.key === 'ArrowRight') { pause(); go(idx + 1); } });
      tt.addEventListener('mouseenter', pause); tt.addEventListener('mouseleave', play);
      tt.addEventListener('focusin', pause);
      var buy = tt.querySelector('[data-tt-buy]');
      if (buy) buy.addEventListener('pointerdown', function () { held = true; pause(); });
      /* drag / swipe */
      var sx = null;
      var stage = tt.querySelector('.nx-tt__stage');
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; pause(); });
      window.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 30) go(idx + (dx < 0 ? 1 : -1)); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? play() : pause(); }, { threshold: 0.35 }).observe(tt);
      } else { visible = true; }
      document.addEventListener('visibilitychange', function () { document.hidden ? pause() : play(); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { layout(); }).observe(stage); else window.addEventListener('resize', layout);
      layout();
      tt.classList.add('is-ready');
      /* start motion after the page has loaded so the first card stays the LCP image */
      if (document.readyState === 'complete') play(); else window.addEventListener('load', play);
    });
  }

  /* Swipe rows: arrow buttons scroll by one card. Lazy-play muted clips while on screen. */
  function initSnap() {
    document.querySelectorAll('[data-nx-snap]').forEach(function (wrap) {
      var row = wrap.querySelector('.nx-snap'); if (!row) return;
      var by = function (dir) { var card = row.firstElementChild; var w = card ? card.getBoundingClientRect().width + 14 : 300; row.scrollBy({ left: dir * w, behavior: still() ? 'auto' : 'smooth' }); };
      wrap.querySelectorAll('[data-snap-prev]').forEach(function (b) { b.addEventListener('click', function () { by(-1); }); });
      wrap.querySelectorAll('[data-snap-next]').forEach(function (b) { b.addEventListener('click', function () { by(1); }); });
    });
    var vids = document.querySelectorAll('video[data-src]');
    if (!vids.length) return;
    var load = function (v) { if (!v.src) v.src = v.dataset.src; if (!still()) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) load(e.target); else if (e.target.pause) e.target.pause(); }); }, { rootMargin: '0px 200px', threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Sticky shop bar: appears once its trigger element has scrolled out of view. */
  function initSticky() {
    document.querySelectorAll('[data-nx-sticky]').forEach(function (bar) {
      var trig = document.querySelector(bar.getAttribute('data-nx-sticky'));
      if (!trig || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) { var e = es[0]; bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(trig);
    });
  }

  /* Crossfade gallery (B2B heroes): cycles real project photos while visible. Static under reduced motion. */
  function initFade() {
    document.querySelectorAll('[data-nx-fade]').forEach(function (box) {
      var items = box.querySelectorAll('.nxb-fade__item'), dots = box.querySelectorAll('.nxb-fade__dots span');
      if (items.length < 2 || still()) return;
      var i = 0, timer = null;
      var show = function (n) { items[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on'); i = n % items.length; items[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on'); };
      var play = function () { if (!timer) timer = setInterval(function () { show(i + 1); }, 4200); };
      var pause = function () { clearInterval(timer); timer = null; };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es[0].isIntersecting ? play() : pause(); }, { threshold: 0.3 }).observe(box); else play();
    });
  }

  function init() { initReveal(); initAnnouncements(); initTurntable(); initSnap(); initSticky(); initFade(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
